export default {
    namespaced: true,
    state: {
        toasts: []
    },
    actions: {
        error({ commit }, message) {
            commit('pushToast', { type: 'error', message });
        },
        success({ commit }, message) {
            commit('pushToast', { type: 'success', message });
        },
        info({ commit }, message) {
            commit('pushToast', { type: 'info', message });
        },
        collecation({ commit }) {
            commit('collecation');
        }
    },
    mutations: {
        pushToast(state, data) {
            state.toasts.push({
                time: data.time || 100,
                type: data.type,
                remove: false,
                clicked: false,
                message: data.message
            });
        },
        collection(state) {
            state.toasts = state.toasts.filter((toast) => toast.remove === false);
        }
    },
    getters: {
        toasts(state) {
            return state.toasts;
        }
    }
};
